/**
 * Chevron Left Icon Component
 *
 * Left chevron icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/chevron-left-icon
 */
import { createIconNode } from '../create-icon';
const CHEVRON_LEFT_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [{ d: 'M9.5 4.5L6.5 8L9.5 11.5', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' }],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [{ d: 'M14.5001 6.5L9.49989 12L14.5001 17.5', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' }],
    },
});
export function ChevronLeftIcon(props) {
    return createIconNode(CHEVRON_LEFT_ICON, props);
}
//# sourceMappingURL=chevron-left.js.map